<template>
    <td>
        <div class="d-flex flex-row justify-content-end align-items-center h-3em">
            <slot/>
        </div>
    </td>
</template>

<script>
export default {
    props: {},
}
</script>
